import {IFilterFunction} from "angular";
import {WidgetType} from "../models/WidgetType";

export const WidgetTranslationId = "tfWidgetTranslationId";

export function widgetTranslationId(): IFilterFunction {
    return (widget: WidgetType | null) => {
        if (widget == null) {
            return null;
        } else {
            return `dashboard.${widget}`;
        }
    };
}
